var CompanySize = {
	"Company size": "회사 규모",
	"1-19 employees": "1~19명의 직원",
	"20-99 employees": "20~99명의 직원",
	"100-499 employees": "100~499명의 직원",
	"500-999 employees": "500~999명의 직원",
	"1,000-9,999 employees": "1,000~9,999명의 직원",
	"10,000 employees or more": "직원 10,000명 이상"
};

export { CompanySize as default };
